import React, { useEffect, useRef, useState } from "react";
import PaginationNew from "../common/Pagination";
import api from "../../seller-apis/api";
import { useDispatch } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { useAlert } from "react-alert";
import { GenUtilities } from "../../utilities/GenUtilities";
var filterData = {
    pageNo: 1,
    size: 12,
};

function BrandTransactions(props) {
    const [transaction, setTransaction] = useState([]);
    const [totalrecords, setTotalRecords] = useState();
    const [selectedPage, setSelectedPage] = useState(1);
    const [ennewloader, setennewloader] = useState("flex");
    const alert = useAlert();
    useEffect(() => {
        setennewloader("flex");
        getTransaction(filterData);
    }, []);

    const applyFilter = (status) => {
        setSelectedPage(1)
        filterData.pageNo = 1;
        filterData["filter"] = {
            status
        };
        setennewloader("flex");
        getTransaction(filterData);
    };

    async function getTransaction(data = filterData) {
        try {
            const res = await api.brand.brandTransaction(data)
            setTransaction(res.data.records);
            setTotalRecords(res.data.totalRecords);
            setennewloader("none");
        }
        catch (err) {
            setennewloader("none");
        }
    }
    async function paginate(data) {
        filterData = {
            ...filterData,
            pageNo: data.number,
            size: 12,
        };
        let outerdiv = document.getElementById("orDeskContain");
        console.log(outerdiv)
        let loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        await getTransaction(filterData);
        setSelectedPage(data.number);
        loaderDiv.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
        setennewloader("none")
    }

    const handleDownload = (pdfUrl) => {
        const link = document.createElement('a');
        link.href = `https://s3.toolsvilla.com/${pdfUrl}`;
        link.target = '_blank';
        link.download = 'downloaded_file.pdf';
        link.click();
    };

    const statusFormatter = (status) => {
        switch (status) {
            case 'COMPLETED':
                return <p className="text-success">{status} <i className="bi bi-check-circle"></i></p>
            case 'FAILED':
                return <p className="text-danger">{status} <i className="bi bi-x-circle"></i></p>
            case 'PENDING':
                return <p className="text-secondary">{status} <i className="bi bi-hourglass-top"></i></p>
            default:
                return <p>{status}</p>
        }

    }

    return (
        <>
            <div className="question-container" id="orDeskContain" >
                <table className="w-100 new-table-design pt-2">
                    <tr>
                        <th>Date</th>
                        <th>Brand</th>
                        <th>Amount</th>
                        <th>
                            Net Amount <br />
                            (Incl Tax)
                        </th>
                        {/* <th>Type</th> */}
                        <th>Status
                            <br></br>
                            <select
                                onChange={(e) => applyFilter(e.target.value)}
                                className="table_th_filter mb-2"
                            >
                                <option value="">All</option>
                                <option value="COMPLETED">COMPLETED</option>
                                <option value="PENDING">PENDING</option>
                                <option value="FAILED">FAILED</option>
                            </select>
                        </th>
                        <th>Details</th>
                        <th>Action</th>
                    </tr>
                    {transaction.length > 0 &&
                        transaction.map((item, index) => {

                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="border-x">
                                            {formatedDate(item?.createdAt)}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="border-x">
                                            {
                                                item?.trademark_reqs_id?.brandName
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className=" text-left border-x px-2">
                                            &#8377; {item?.amount}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="border-x">
                                            &#8377;{" "}
                                            {Math.round(parseInt(item.amount) +
                                                (parseInt(item.amount) * 18) / 100)}
                                        </div>
                                    </td>

                                    <td>
                                        <div className="border-x">
                                            {
                                                statusFormatter(item?.status)
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div className="border-x">{item?.razorpay.id}</div>
                                    </td>
                                    <td>
                                        <div className={`border-x`}>
                                            {item?.brandInvoice ? <button className="download_manifest_btn_orders manifest_fresh_btn w-80 mt-2" onClick={() => handleDownload(item.brandInvoice)}>Download Invoice</button> : "Invoice not generated yet"}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    {ennewloader === "none" && transaction.length == 0 ? (
                        <tr>
                            <td className="py-2" colspan="99">
                                No data found
                            </td>
                        </tr>
                    ) : (
                        <></>
                    )}
                </table>
                <div class="d-flex justify-content-center" id="enNewLoader" >
                    <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
                        <span class="sr-only"></span>
                    </div>
                </div>
                <PaginationNew
                    number={totalrecords}
                    paginate={paginate}
                    activ={selectedPage}
                    comp={"details"}
                />
            </div>
        </>
    );
}

export default BrandTransactions;
